import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CaretLeft, Question, Envelope, Globe, ChatCircle } from 'phosphor-react';
import '../styles/design-system.css';
import '../styles/HelpPage.css';

function HelpPage() {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/');
  };

  return (
    <div className="help-page">
      <div className="page-header">
        <button className="back-button" onClick={handleBackClick}>
          <CaretLeft size={24} weight="bold" />
        </button>
        <h1 className="page-title">Help & Support</h1>
        <div className="header-spacer"></div>
      </div>

      <div className="page-content">
        <div className="content-section">
          <h2 className="section-title">
            Quick Start
          </h2>
          
          <div className="help-item">
            <h3 className="subsection-title">Creating a Match</h3>
            <ol className="body-text">
              <li>Tap "Create a new match".</li>
              <li>Fill out the names of the teams playing and select their colors</li>
              <li>Start scoring!</li>
            </ol>
          </div>

          <div className="help-item">
            <h3 className="subsection-title">Sharing Live Scores</h3>
            <ol className="body-text">
              <li>Let people scan the QR code</li>
              <li>Open it for a bigger version or copy the link</li>
              <li>Share via your texting platform</li>
            </ol>
          </div>

          <div className="help-item">
            <h3 className="subsection-title">Scoring Rules</h3>
            <p className="body-text">
              Use + and - buttons to adjust scores. Tap "Next Set" when a set is complete according to your league's rules.
            </p>
          </div>
        </div>

        <div className="content-section">
          <h2 className="section-title">
            Get Help
          </h2>
          
          <div className="help-item">
            <p className="body-text">
              Submit a bug, request, or feedback to our issue tracker. All issues are tracked and prioritized for future updates.
            </p>
            <a 
              href="https://tally.so/r/wdBeoV" 
              target="_blank" 
              rel="noopener noreferrer"
              className="linear-link"
            >
              <ChatCircle size={16} weight="bold" />
              Talk to Us
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}

export default HelpPage;
